import actionTypes from './actionTypes';
import commonAPI from './commonAPI';
import * as toastr from 'toastr';

const commonActions = {
	contactUs: (form: any) => {
		return (dispatch: any) => {
			return commonAPI.contactUs(form)
				.then(success => {
					dispatch({ type: actionTypes.CONTACT_US_SUCCESS, success });
				})
				.catch(e => (toastr.error('Failed to submit')));
		};
	},
	fileAClaim: (form: any) => {
		return (dispatch: any) => {
			return commonAPI.fileAClaim(form)
				.then(success => {
					dispatch({ type: actionTypes.FILE_A_CLAIM_SUCCESS, success });
				})
				.catch(e => (toastr.error('Failed to submit')));
		};
	}
};

export default commonActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/commonActions.ts